import React from 'react'
import { Box, Typography } from '@material-ui/core'
import WhatsAppConnectionPanel from '../../components/whatsapp/WhatsAppConnectionPanel'

export default function WhatsAppConnectionPage() {
  return (
    <Box>
      <WhatsAppConnectionPanel />
    </Box>
  )
}
